export type SolveConnectorPlacementModelMode =
    (typeof SolveConnectorPlacementModelMode)[keyof typeof SolveConnectorPlacementModelMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SolveConnectorPlacementModelMode = {
    Automatic: 'Automatic',
    Manual: 'Manual'
} as const;
